import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subject, pipe } from 'rxjs';

import { FeitoConferido } from '../feito-conferido';
import { FeitoConferidoService } from '../feito-conferido.service';
import { HttpErrorResponse } from '@angular/common/http';
import { indicate } from "src/app/shared/util/loading-indicate";

@Component({
  selector: 'app-feito-conferido-acoes',
  templateUrl: './feito-conferido-acoes.component.html',
  styleUrls: ['./feito-conferido-acoes.component.scss']
})
export class FeitoConferidoAcoesComponent implements OnInit {

  @Input() feitoConferido: FeitoConferido;

  @Output() error: EventEmitter<string> = new EventEmitter<string>();
  @Output() exibir: EventEmitter<FeitoConferido> = new EventEmitter<FeitoConferido>();
  @Output() autorizado: EventEmitter<number> = new EventEmitter<number>();
  @Output() rejeitado: EventEmitter<number> = new EventEmitter<number>();

  public loadingAutorizacao$: Subject<boolean> = new Subject<boolean>();
  public loadingRejeicao$: Subject<boolean> = new Subject<boolean>();

  constructor(private readonly feitoConferidoService: FeitoConferidoService) { }

  ngOnInit(): void {
  }

  fireEventExibir()
  {
    this.exibir.emit(this.feitoConferido);
  }

  autorizar() {
    this.feitoConferidoService
      .authorize(this.feitoConferido.id)
      .pipe(
        indicate(this.loadingAutorizacao$)
      ).subscribe(
        () => {
          this.autorizado.emit(this.feitoConferido.id);
        },
        (err: HttpErrorResponse)=> this.error.emit(err.error.message)
      );
  }

  rejeitar(){
    this.feitoConferidoService
      .reject(this.feitoConferido.id)
      .pipe(
        indicate(this.loadingRejeicao$)
      ).subscribe(
      () => {
        this.rejeitado.emit(this.feitoConferido.id);
      },
      (err: HttpErrorResponse)=> this.error.emit(err.error.message)
    );
  }
}
